import MainLayout from "../layouts/MainLayout";
// import Home from "../pages/Home";
import Logout from "../pages/Logout"

import { ComponentType } from "react";
import Sponsorships from "../pages/Sponsorships";
import NotFound from "../pages/system/NotFound";
// import ConnectIGStatus from "../pages/auth/ConnectIGStatus";
import Profile from "../pages/Profile";
import Referral from "../pages/Referral/index";
import Membership from "../pages/Membership/index";
import Wallet from "../pages/Wallet";
import CampaignPublic from "../pages/public/Campaign";
import ConversionCampaignPublic from "../pages/public/ConversionCampaign";
import PublicLayout from "../layouts/PublicLayout";
import DMAutomations from "../pages/DMAutomations";
import { CAP_IG_AUTH_REDIRECT_ROUTE, IG_AUTH_REDIRECT_ROUTE, IG_HANDLE_INPUT_ROUTE, IG_HANDLE_VERIFICATION_ROUTE, INIT_IG_AUTH_ROUTE } from "../constants/constants";
import ConnectIGRedir from "../pages/auth/ConnectIGRedir";
import CollaborationMilestones from "../pages/CollaborationMilestones";
import ConversionCampaigns from "../pages/ConversionCampaigns";
import ConversionCampaign from "../pages/ConversionCampaign";
import Register from "../pages/auth/Register";
import Login from "../pages/auth/Login";
import ConnectIG from "../pages/auth/ConnectIG";
import ConnectIGHandle from "../pages/auth/ConnectIGHandle";
import ConnectIGHandleVerify from "../pages/auth/ConnectIGHandleVerify";
import CollaborationsNew from "../pages/CollaborationsNew";
import BrowserPermissionHelp from "../pages/BrowserPermissionHelp";
import CollaborationChat from "../pages/CollaborationChat";
import SocialAccount from "../pages/Profile/SocialAccount";
import PricingPublic from "../pages/public/Pricing";
import AccountDeletion from "../pages/public/AccountDeletion";
import Pricing from "../pages/Pricing/index";
import ConnectIGRedirCap from "../pages/auth/ConnectIGRedirCap";
import AppReview from "../pages/AppReview";
import { isNativePlatform } from "../utils/platformUtil";
import RegistrationSuccess from "../pages/auth/RegistrationSuccess";
import Home from "../pages/Home";
import SmartLinks from "../pages/SmartLinks";
import Applications from "../pages/Applications";
import { Navigate } from "react-router-dom";
import Campaign from "../pages/Campaign/index";
import ProfilePage from "../pages/Profile/index";
import Chat from "../pages/Chat";
import Collaboration from "../pages/Collaboration";
import ConversionCampaignCommissions from "../components/conversionCampaign/ConversionCampaignCommissions";
import Offer from "../components/conversionCampaign/MyProgress/Offer/Offer";

export interface Route {
    path: string; // The route's path
    element: React.FC; // The component to render
    title?: string; // Title of the route
    layout?: ComponentType<any> | null; // Layout for the route; null means no layout
    authRequired?: boolean; // Indicates if authentication is required
    cache?: boolean; // Determines if the route should use caching
    children?: Route[]; // Nested routes
    showBackButton?: boolean,
    redirect?: string,
    [key: string]: any; // Allow additional custom properties
}

export const routes: Route[] = [
    {
        path: "/login",
        element: Login,
        title: "Login",
    },
    {
        path: "/register",
        element: Register,
        title: "Register",
    },
    {
        path: "/registration-success",
        element: RegistrationSuccess,
        title: "Registration Success",
    },
    {
        path: INIT_IG_AUTH_ROUTE,
        element: ConnectIG,
        title: 'Connect Instagram'
    },
    {
        path: IG_AUTH_REDIRECT_ROUTE,
        element: ConnectIGRedir,
        title: 'Connect Instagram'
    },
    {
        path: CAP_IG_AUTH_REDIRECT_ROUTE,
        element: isNativePlatform() ? ConnectIGRedir : ConnectIGRedirCap,
        title: 'Connect Instagram'
    },
    {
        path: IG_HANDLE_INPUT_ROUTE,
        element: ConnectIGHandle,
        title: 'Connect Instagram'
    },
    {
        path: IG_HANDLE_VERIFICATION_ROUTE,
        element: ConnectIGHandleVerify,
        title: 'Connect Instagram'
    },
    // {
    //     path: "/c/ig/status",
    //     element: ConnectIGStatus,
    //     title: 'Instagram Connection Status'
    // },
    {
        path: "/logout",
        element: Logout,
        title: "Logout"
    },
    {
        path: "/app-review",
        element: AppReview,
        title: "AppReview",
    },
    {
        path: "/",
        element: MainLayout,
        authRequired: true,
        children: [
            {
                path: "/",
                parent: 'dashboard',
                element: Home,
            },
            {
                path: "/campaign",
                parent: 'dashboard',
                element: Sponsorships,
            },
            {
                path: "/campaign/:campaignId",
                parent: 'dashboard',
                element: Campaign,
                title: "Campaign",
            },
            {
                path: "/i/me",
                parent: 'dashboard',
                element: ProfilePage,
                title: "My Profile"
            },
            {
                path: "/i/me/collaboration",
                parent: 'dashboard',
                element: Applications,
                redirect: '/collaborations',
                title: "Collaborations"
            },
            {
                path: "/collaborations",
                parent: 'dashboard',
                element: Applications,
                title: "Collaborations"
            },
            {
                path: "/applications",
                parent: 'dashboard',
                element: Applications,
                title: "Collaborations"
            },
            {
                path: "/collaborations/:campaignId",
                parent: 'dashboard',
                element: CollaborationMilestones,
                title: "Collaboration Milestones"
            },
            {
                path: "/collaborations/:campaignId/milestone/:milestoneId",
                parent: 'dashboard',
                element: Collaboration,
                title: "Collaboration"
            },
            {
                path: "/chat",
                parent: 'dashboard',
                element: Chat,
                title: "Chats"
            },
            {
                path: "/chat/:uuid",
                parent: 'dashboard',
                element: Chat,
                title: "Chats"
            },
            {
                path: '/referral',
                parent: 'dashboard',
                element: Referral,
                title: 'Refer and Earn'
            },
            {
                path: "/i/me/membership",
                parent: 'dashboard',
                element: Membership,
                redirect: '/subscription',
                title: "Subscription"
            },
            {
                path: '/membership',
                parent: 'dashboard',
                element: Membership,
                redirect: '/subscription',
                title: 'Subscription'
            },
            {
                path: '/subscription',
                parent: 'dashboard',
                element: Membership,
                title: 'Subscription'
            },
            {
                path: '/i/pricing',
                parent: 'dashboard',
                element: Pricing,
                redirect: '/subscription-plans',
                title: "Subscription Plans"
            },
            {
                path: '/subscription-plans',
                parent: 'dashboard',
                element: Pricing,
                title: "Subscription Plans"
            },
            {
                path: '/i/me/wallet',
                parent: 'dashboard',
                element: Wallet,
                title: 'Wallet'
            },
            {
                path: '/wallet',
                parent: 'dashboard',
                element: Wallet,
                title: 'Wallet'
            },
            {
                path: '/smart-links',
                parent: 'dashboard',
                element: SmartLinks,
                title: 'Smart Links'
            },
            {
                path: "/conversion",
                parent: 'dashboard',
                element: ConversionCampaigns,
                title: 'Share and Earn'
            },
            {
                path: "/conversion/earning",
                parent: 'dashboard',
                element: ConversionCampaigns,
                title: 'My Earnings'
            },
            {
                path: "/conversion/:campaignId",
                parent: 'dashboard',
                element: ConversionCampaign,
            },
            {
                path: "/conversion/:campaignId/offer/:offerId",
                parent: 'dashboard',
                element: Offer,
            },
            {
                path: "/help/location",
                parent: "dashboard",
                element: BrowserPermissionHelp,
                title: 'Help - Location'
            },
            {
                path: "/i/social-account/:socialAccountId",
                parent: 'dashboard',
                element: SocialAccount,
                title: "Account Details"
            },
            {
                path: "*",
                parent: 'dashboard',
                element: NotFound,
                showBackButton: true,
            }
        ],
    },
    {
        path: "/",
        element: PublicLayout,
        children: [
            {
                path: "/c/:campaignId",
                element: CampaignPublic,
                title: "Campaign",
            },
            {
                path: "/cc/:campaignId",
                element: ConversionCampaignPublic,
                title: "Share and Earn",
            },
            {
                path: "/pricing",
                element: PricingPublic,
                title: "Membership",
            },
            {
                path: "/delete-account",
                element: AccountDeletion,
                title: "Delete Account"
            }
        ]
    },

];